<template >
    <div class="tv container" @mousemove="showBox" >
        <div class="page_loader_cont" v-if="page_loader">
            <div class="spinner_height">
                <spinner-circle :black="true"></spinner-circle>
            </div>
        </div>

        <div class="tv_cont" >

            <!-- check :class="column waitting_cont_tv" || "column waitting_cont_tv empty_widgets" -->
            <div class="column waitting_cont_tv bgg" :class="{ 'empty_widget': showeringSessions.length === 0 }">
                <div class="row cen upanddown_cont">
                    <h1 class="showering_heading">SHOWERING</h1>
                    <!-- if there is data available -->
                    <div v-if="showeringSessions.length > 0" class="row pets_profile pets_profiles">
                        <!-- loop for div-->
                        <div class="" v-for="session in showeringSessions" :key="session.id">
                            <div class="row pet_conttt">
                                <!-- add pet profile picture -->
                                <div class="pet_profile_pic bgggx" v-if="session.pet_pic !== null && session.pet_pic !== ''" :style="{ backgroundImage: `url(${linkk}/${session.pet_pic})` }"></div>
                                <!-- if cat with no profile picture add cat icon and one for dog  -->
                                <div class="pet_profile_pic bgpet sh" v-else-if="session.pet_type === 'cat' && session.pet_pic === null" :style="{ backgroundImage: `url(${require('@/assets/cat.svg')})` }"></div>
                                <div class="pet_profile_pic bgpet sh" v-else-if="session.pet_type === 'dog' && session.pet_pic === null" :style="{ backgroundImage: `url(${require('@/assets/dog.svg')})` }"></div>
                                <div class="pet_profile_pic" v-else></div>


                                <div class="pet_name_tv">
                                    <div>{{ truncateText(session.pet_name, 7) }}</div>
                                    <div class="pet_quee_number">
                                        <span v-if="session.quee_number">#{{ session.quee_number }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- if there is no data available -->
                    <div v-else class="row pets_profile">
                        <div>No showering sessions currently.</div>
                    </div>


                </div>
            </div>

            <!-- video -->
            <div class="video_container">
                <video autoplay muted loop playsinline>
                    <source :src="tv_video" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>

            <div class="column waitting_cont_tv waitting_cont_tv_up_next">
                <div class="row cen">
                    <h1 class="showering_heading showering_heading_up_next">UP NEXT</h1>
                    <div v-if="waitingSessions.length > 0" class="pets_profile pets_profiles">
                        <!-- loop for div-->
                        <div class="" v-for="session in waitingSessions" :key="session.id">
                            <div class="row pet_conttt">
                                <!-- check if pet has a profile picture -->
                                <div class="pet_profile_pic bgggx" v-if="session.pet_pic !== null && session.pet_pic !== ''" :style="{ backgroundImage: `url(${linkk}/${session.pet_pic})` }"></div>
                                <!-- if cat with no profile picture add cat icon and one for dog  -->
                                <div class="pet_profile_pic bgpet wa" v-else-if="session.pet_type === 'cat' && session.pet_pic === null" :style="{ backgroundImage: `url(${require('@/assets/cat.svg')})` }"></div>
                                <div class="pet_profile_pic bgpet wa" v-else-if="session.pet_type === 'dog' && session.pet_pic === null" :style="{ backgroundImage: `url(${require('@/assets/dog.svg')})` }"></div>
                                <div class="pet_profile_pic" v-else></div>


                                <div class="pet_name_tv">
                                    <div>{{ truncateText(session.pet_name, 7) }}</div>
                                    <div class="pet_quee_number">
                                        <span v-if="session.quee_number">#{{ session.quee_number }}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-else class="row pets_profile">
                        <div>No waiting sessions currently.</div>
                    </div>
                </div>
            </div>

        </div>
        <div class="logout" v-if="visible">
            <button @click="logout">Logout</button>
        </div>
    </div>
</template>
<script>
import request from '../axios_request';
import SocketioService from '@/services/socketio.service.js';
import SpinnerCircle from './SpinnerCircle.vue';
import tv_video from '@/assets/ziggy_tv.mp4';



export default {
    name: 'TV',
    components: {
        SpinnerCircle
    },
    data() {
        return {
            // You can add any data properties you need here
            showeringSessions: [], // This will hold the showering sessions data fetched from the server
            waitingSessions: [], // This will hold the waiting sessions data fetched from the server
            page_loader: true,// This will hold the loading state for the page
            linkk: process.env.VUE_APP_SERVER_ENDPOINT,
            visible: false,
            timer: null,
            tv_video: tv_video

        };
    },
    //now get this from api /get_showering_sessions_for_tv 
    created() {
        if (!localStorage.getItem('token')) {
            // If the token is not found, redirect to the login page
            this.$router.push('/login');
            return;
        }

        // Fetch showering sessions data from the server when the component is created
        request.post('/api/session/get_showering_sessions_for_tv'
        // add Authorization
        , {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        }

        )
            .then(response => {
                // Assuming the response contains an array of showering sessions
                this.page_loader = false;
                if( response.data && response.data.showeringSessions && response.data.waitingSessions){
                    this.showeringSessions = response.data.showeringSessions;
                    this.waitingSessions = response.data.waitingSessions;
                    console.log('Showering sessions data:', this.showeringSessions);
                    console.log('Waiting sessions data:', this.waitingSessions);
                }

                // if status is forbidden, redirect to login
                if (response.status === 403) {
                    this.$router.push('/login');
                }
            })
            .catch(error => {
                console.error('Error fetching showering sessions:', error);
            });

    },
    mounted() {
        // Listen for real-time updates using Socket.io
        SocketioService.socket.on('sess_update', () => {
            // Fetch the updated showering sessions data from the server
            request.post('/api/session/get_showering_sessions_for_tv', {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => {
                    if( response.data && response.data.showeringSessions && response.data.waitingSessions){
                        this.showeringSessions = response.data.showeringSessions;
                        this.waitingSessions = response.data.waitingSessions;
                    }
                })
                .catch(error => {
                    console.error('Error fetching updated showering sessions:', error);
                });
        });

        // new_session

        SocketioService.socket.on('new_session', () => {
            // Fetch the updated showering sessions data from the server
            request.post('/api/session/get_showering_sessions_for_tv', {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => {
                    if( response.data && response.data.showeringSessions && response.data.waitingSessions){
                        this.showeringSessions = response.data.showeringSessions;
                        this.waitingSessions = response.data.waitingSessions;
                    }
                })
                .catch(error => {
                    console.error('Error fetching updated showering sessions:', error);
                });
        });



    },
    methods: {
        // You can add any methods you need here
        truncateText(text, length = 10) {
            if (!text) return '';
            return text.length > length
                ? text.slice(0, length) + '...'
                : text;
        },
        showBox() {
      this.visible = true

      // hide again after 1 second of no movement
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = false
      }, 1000)
    },
        logout() {
            // Clear the token from localStorage
            localStorage.removeItem('token');
            // Redirect to the login page
            this.$router.push('/login');
        }

    }
    }
</script>

<style scoped>
.tv {
    background-color: #f0f0f0;
    border-radius: 8px;
    font-family: 'nunito', sans-serif;
}

.tv p {
    color: #666;
    font-size: 16px;
}

.tv_cont{
    /* width: 80vw; */
    background-color: none;
    width: 95%;
    aspect-ratio: 19 / 6;
    min-width: 50vw;
}

.container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 2vh 0px;
    height: 100vh;
}

.waitting_cont_tv{
    background-color: #f8fcff;
    border: 5px solid #01bcfe;
    border-radius: 5px 5px 0px 0px;
    /* padding: 10px 15px; */
    padding: 1vh 1vw;
    align-items: center;
    justify-content: center;
}

.waitting_cont_tv_up_next{
    border-radius: 0px 0px 5px 5px;
    background-color: #fcfac9;
    border: 5px solid #f4e914;
    align-items: center;
    justify-content: center;
}

.bgg{
  background-image: url('@/assets/bg.svg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
}

.waitting_cont_tv{
    max-height: 20vh;
    height: 100%;
    height: 20vh;
}

.showering_heading_up_next{
    color: #dbd001 !important;
    /* margin-right: 3vw; */
}

.showering_heading{
    color: #28aae3;
    font-weight: bold;
    margin: 0px;
    font-size: 24px;
}

.pet_name_tv{
    color: #365889;
    font-weight: bold;
}

.pet_profile_pic{
    width: 6vh;
    height: 6vh;
    background-color: #ccc;
    border-radius: 50%;
    margin-right: 10px;
}

.pet_conttt{
    align-items: center;
    /*justify-content: center;*/
    /* margin-right: 10px; */
}

/* .video_container video{ */
    /* max-height: 80vw; */
    /* margin: 0px 10px; */
/* } */

.video_container{
    max-height: 50vh;
    height: 100%;
    height: 50vh;
    /* border: 4px solid #c2c8cb; */
    margin: 10px 0px;
    background-color: #f2f7fa; /* #393939 */
}

.empty_widget{
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.video_container video{
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.cen{
    justify-content: space-around;
    align-items: center;
    width: 100%;
}

.bgggx{
    background-size: cover;
    background-position: center;

}

.bgpet{
    background-size: 70%;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
}

.sh{
    border: 2px solid #365889;
}

.pet_quee_number{
    font-size: smaller;
}

.wa{
    border: 2px solid #365889;
}

.pets_profiles{
    /* flex-wrap: wrap; */
    width: 60%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}
/* .pet_conttt:last-child{
    margin-right: 0;
} */


.page_loader_cont{
    z-index: 2;
}
.logout{
    position: fixed;
    right: 0px;
    bottom: 0px;
    z-index: 1;
}
</style>